const name = 'FloatIn';
const properties = {
    hideOnStart: true,
    mobile: true,
    viewportThreshold: 0.15,
    groups: ['entrance', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        direction: {
            type: 'string',
            enum: ['top', 'right', 'bottom', 'left'],
            default: 'right',
        },
    },
};
const paramsMap = {
    top: { dx: 0, dy: -1, distance: 50 },
    right: { dx: 1, dy: 0, distance: 50 },
    bottom: { dx: 0, dy: 1, distance: 50 },
    left: { dx: -1, dy: 0, distance: 50 },
};
function animate(kit, elements, duration, delay, { direction = properties.schema.direction.default, ...params } = {}) {
    const fromParams = paramsMap[direction];
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'Cubic.easeInOut',
    }));
    elements.forEach((element) => {
        const transformX = fromParams.dx * fromParams.distance;
        const transformY = fromParams.dy * fromParams.distance;
        sequence.add(kit.animate('BasePosition', element, duration, delay, {
            from: { x: transformX, y: transformY },
            ease: 'Quad.easeInOut',
        }), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=floatIn.js.map